import { render, staticRenderFns } from "./PerformanceRule.vue?vue&type=template&id=712d20a6&scoped=true"
import script from "./PerformanceRule.vue?vue&type=script&lang=js"
export * from "./PerformanceRule.vue?vue&type=script&lang=js"
import style0 from "./PerformanceRule.vue?vue&type=style&index=0&id=712d20a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712d20a6",
  null
  
)

export default component.exports